export default "__VITE_ASSET__Ck4y8IBm__"